export default __webpack_public_path__ + "static/media/primate.e83a7e05.jpg";